<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row no-gutters>
        <v-col cols="12">
          <v-text-field
            :label="
              $t('components.miscellaneous.userEmailInvite.enterEMailAddress')
            "
            append-icon=""
            v-model="userEmailToAdd"
            color="primary"
            autocomplete="off"
            :rules="emailRules"
          >
            <template v-slot:append-outer>
              <slot name="locale"></slot>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" class="mb-4 mt-0">
          <slot name="button"></slot>
        </v-col>
      </v-row>
    </v-form>
    <v-list v-for="(user, index) in userEmails" :key="user.email">
      <div v-if="index == 0">
        <div :class="{ 'show-margin': showMargin }">
          <user-email-component
            :readonly="false"
            :user="user"
            @delete-user="deleteUser(user)"
            :invite="true"
            :contact-email="contactEmail"
          />
        </div>
      </div>
      <div v-else>
        <user-email-component
          :readonly="false"
          :user="user"
          @delete-user="deleteUser(user)"
          :invite="true"
          :contact-email="contactEmail"
        />
      </div>
    </v-list>
    <warning-dialog
      :dialog="inviteDialog.active"
      :text="inviteDialog.text"
      :title="inviteDialog.title"
      @agree="handleInviteDialogOutput"
      :confirm="$t('components.miscellaneous.userEmailInvite.yes')"
      :reject="$t('components.miscellaneous.userEmailInvite.no')"
      v-show="false"
    />
    <warning-dialog
      :dialog="cancelDialog.active"
      :text="cancelDialog.text"
      :title="cancelDialog.title"
      @agree="handleCancelDialogOutput"
      :confirm="$t('components.miscellaneous.userEmailInvite.yes')"
      :reject="$t('components.miscellaneous.userEmailInvite.no')"
      v-show="false"
    />
  </div>
</template>

<script>
import WarningDialog from "@/components/dialogs/WarningDialog.vue";
import UserEmailComponent from "@/components/miscellaneous/UserEmailComponent";

export default {
  name: "UserEmailPicker",
  components: { UserEmailComponent, WarningDialog },
  props: ["initial_data", "notAvailable", "contactEmail"],
  data: () => ({
    inviteDialog: {},
    cancelDialog: {},
    showMargin: false,
    isEditView: false,
    userEmailToAdd: null,
    userOptions: [],
    userEmails: [],
    user: {},
    emailRules: [],
    valid: false,
  }),
  created() {
    this.setInitalData();
    if (
      typeof this.initial_data !== "undefined" &&
      this.initial_data.length !== 0
    ) {
      this.userEmails = this.initial_data;
    }
  },

  methods: {
    setInitalData() {
      this.inviteDialog = {
        active: false,
        title: this.$t("components.miscellaneous.userEmailInvite.inviteUser"),
        text: "",
      };
      this.cancelDialog = {
        active: false,
        title: this.$t("components.miscellaneous.userEmailInvite.cancelInvite"),
        text: this.$t(
          "components.miscellaneous.userEmailInvite.areYouSureYouWantToCancelTheInvite"
        ),
      };

      this.emailRules = [
        (v) =>
          /[^@]+@[^.]+\..*/.test(v) ||
          this.$t(
            "components.dialogs.linkedPartnerAddEditDialog.eMailMustBeValid"
          ),
      ];
    },
    handleInviteDialogOutput(agreed) {
      if (agreed) {
        const self = this;
        this.$emit("invite-user", this.user, function (done, status) {
          if (done) {
            self.$nextTick(() => {
              self.userEmailToAdd = null;
              if (!status) {
                self.userEmails.push(done.data);
              }
            });
          }
        });
      } else {
        this.userEmailToAdd = null;
      }
      this.inviteDialog.active = false;
    },
    handleCancelDialogOutput(agreed) {
      this.loading = false;
      if (agreed) {
        const self = this;
        this.$emit("reject-user", this.user, function (done) {
          if (done) {
            self.$nextTick(() => {
              self.userEmails = self.userEmails.filter(
                (ue) => ue.email !== done.email
              );
            });
          }
        });
      }
      this.cancelDialog.active = false;
    },
    addUser() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.user = this.userEmailToAdd.trim();

      if (this.notAvailable.find((el) => el.username === this.user)) {
        return;
      }

      if (this.userEmails.find((el) => el === this.user)) {
        return;
      }

      this.inviteDialog.text = this.$t(
        "components.miscellaneous.userEmailInvite.areYouSureYouWantToAddUserTheUserWillBeInformedByEmail",
        { user: this.user }
      );
      this.inviteDialog.active = true;
    },
    deleteUser(user) {
      this.user = user;
      this.cancelDialog.active = true;
    },
  },
};
</script>
<style scoped>
.flex-ml-auto {
  margin-left: auto;
}
.show-margin {
  margin-top: 50px;
}
</style>
